import { asString } from './coercion.js'
function uniqueStrings(values = []) {
  return Array.from(new Set(values.map((value) => asString(value)).filter(Boolean)));
}

export function buildHostedConfigStatus({ checks = [] } = {}) {
  const normalizedChecks = Array.isArray(checks) ? checks : [];
  const missing = normalizedChecks
    .filter((check) => check?.present !== true)
    .map((check) => asString(check?.key))
    .filter(Boolean);

  const canRead = !normalizedChecks.some(
    (check) => check?.present !== true && check?.requiredForRead === true
  );
  const canWrite = canRead && !normalizedChecks.some(
    (check) => check?.present !== true && check?.requiredForWrite === true
  );

  let status = "ready";
  if (!canRead) {
    status = "blocked";
  } else if (!canWrite || missing.length > 0) {
    status = "degraded";
  }

  return {
    status,
    missing,
    guidance: uniqueStrings(
      normalizedChecks
        .filter((check) => check?.present !== true)
        .map((check) => asString(check?.guidance))
    ),
    canRead,
    canWrite,
  };
}

export function formatHostedConfigMessage(configStatus, options = {}) {
  const label = asString(options.label) || "Hosted control plane";
  const missing = Array.isArray(configStatus?.missing) ? configStatus.missing : [];
  const guidance = Array.isArray(configStatus?.guidance) ? configStatus.guidance : [];
  if (configStatus?.status === "ready") {
    return `${label} is ready.`;
  }
  const lines = [`${label} is ${asString(configStatus?.status) || "blocked"}.`];
  if (missing.length > 0) {
    lines.push(`Missing: ${missing.join(", ")}.`);
  }
  for (const entry of guidance.slice(0, 4)) {
    lines.push(entry);
  }
  return lines.join(" ");
}
